import React from 'react';
import { connect } from 'react-redux';
import { DBIntFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthPelvicFloorEndurance extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Endurance' />
                <label className={styles.textarea_label}>Pelvic Floor Endurance</label>
                <div className={styles.pelv}>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPELVICFLOORENDURANCE'
                        className={styles.pelv_input}
                    />
                    seconds
                </div>
                <span className={styles.prev_comments_wrapper}>
                    {this.props.prevVal}
                </span>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevVal = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevVal = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORENDURANCE'] + ' seconds';
    }



    return {
        noteId,
        stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno].STPELVICFLOORENDURANCE ? true : false,
        prevVal,
    };
}

const connectedStrengthPelvicFloorEndurance = connect(mapStateToProps)(StrengthPelvicFloorEndurance);
export { connectedStrengthPelvicFloorEndurance as StrengthPelvicFloorEndurance };


